import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("rl_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

export const formatRupiah = (n) => {
  if (n == null) return "Rp 0";
  return "Rp " + Number(n).toLocaleString("id-ID", { maximumFractionDigits: 0 });
};

export const dispDate = (ymd) => {
  if (!ymd) return "-";
  const [y, m, d] = ymd.split("-");
  return `${d}-${m}-${y}`;
};

export const dispDT = (s) => {
  if (!s) return "-";
  // s like 2025-12-01 17:30:00
  const [d, t] = s.split(" ");
  if (!d) return s;
  return `${dispDate(d)} ${t || ""}`.trim();
};

export const todayYMD = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};

export const currentYM = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
};
